export default __webpack_public_path__ + "static/media/601.9a4fb27a.png";